export default __webpack_public_path__ + "static/media/USDT (TRC20).0b1e68f3.jpg";